export { FgResourceToolbarComponent } from './fg-resource-toolbar.component';
export { FgResourceToolbarModule } from './fg-resource-toolbar.module';
